<template>
  <div>
    <b-table
      :items="pcls"
      :fields="fields"
      :busy="isLoaging"
      class="col-12 mt-2 table-views"
      show-empty
    >
      <template #empty>
        <div class="text-center my-2">
          <h2>No hay PCLs registrados</h2>
        </div>
      </template>
      <template #cell(diagnostic)="data">
        <ul class="list-diagnostic">
          <li v-for="item in data.item?.diagnostics2" :key="item?.id">
            {{ item?.name }}
          </li>
        </ul>
      </template>
      <template #cell(percentage)="data">
        {{ `${data?.item?.percentage}%` }}
      </template>
      <template #cell(compensation)="data">
        {{ textCompensation(data?.item?.compensation) }}
      </template>
      <template #cell(filePcl)="data">
        <div class="" v-if="data?.item?.file">
          <a :href="data?.item?.file?.path" target="_blank" class="text-file"
            >Ver archivo adjunto
          </a>
        </div>
        <div v-else>N/A</div>
      </template>
      <template #cell(options)="row">
        <button
          class="button-table-employee"
          :id="`tooltip-button-ver-${row.item?.id}`"
          @click.prevent="findItem(row.item?.id)"
        >
          <img
            class="centerImg1 resaltar"
            :src="require('@/assets/images/icons/eye-line.svg')"
          />
        </button>

        <button
          class="button-table-employee"
          @click.prevent="editItem(row.item?.id)"
          :id="`tooltip-button-edit-${row.item?.id}`"
        >
          <span class="icon-pencil centerImg1 resaltar"> </span>
        </button>

        <button
          class="button-table-employee"
          :id="`tooltip-button-delete-${row.item.id}`"
          @click.prevent="deleteItem(row.item.id)"
        >
          <img
            class="centerImg1 resaltar icondelete"
            :src="require('@/assets/images/icons/delete-bin-2-line.svg')"
          />
        </button>

        <b-tooltip
          :target="`tooltip-button-ver-${row.item.id}`"
          placement="top"
          custom-class="custom-tooltip-ht"
        >
          Ver PCL
        </b-tooltip>
        <b-tooltip
          :target="`tooltip-button-edit-${row.item.id}`"
          placement="top"
          custom-class="custom-tooltip-ht"
        >
          Editar PCL
        </b-tooltip>
        <b-tooltip
          :target="`tooltip-button-delete-${row.item.id}`"
          placement="top"
          custom-class="custom-tooltip-ht"
        >
          Eliminar PCL
        </b-tooltip>
      </template>
      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <overlay-button></overlay-button>
        </div>
      </template>
    </b-table>
    <div class="mt-4" v-if="pcls.length > 1">
      <b-alert show variant="warning" class="alert-warning-message mb-5">
        <div class="d-flex">
          <div class="mr-3">
            <img
              src="@/assets/images/icons/alert-line.svg"
              alt=""
              width="28px"
              height="28px"
            />
          </div>
          <div>
            <h1 style="font-size: 16px; color: #263238; text-transform: none">
              Se han detectado dos registros de pérdida de capacidad laboral
            </h1>
            <p style="color: #263238; font-size: 16px; margin-bottom: 0;">
              Por favor, solicite una calificación integral para consolidar los
              registros en una única calificación
            </p>
          </div>
        </div>
      </b-alert>
    </div>
  </div>
</template>

<script>
import Pagination from "laravel-vue-pagination";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";

export default {
  components: {
    Pagination,
    OverlayButton,
  },
  props: {
    pcls: {
      type: Array,
      default: () => [],
    },
    isLoaging: {
      type: Boolean,
      default: false,
    },
    employeeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      fields: [
        {
          label: "Diagnóstico",
          key: "diagnostic",
        },
        {
          label: "Archivo PCL",
          key: "filePcl",
        },
        {
          label: "Fecha del documento PCL",
          key: "pcl_document_date",
        },
        {
          label: "Porcentaje PCL",
          key: "percentage",
        },
        {
          label: "Compensación",
          key: "compensation",
        },
        {
          label: "Fecha compensación",
          key: "compensation_date",
        },
        {
          label: "",
          key: "options",
        },
      ],
      optionsCompensation: [
        {
          id: "with_compensation",
          name: "Con compensación",
        },
        {
          id: "without_compensation",
          name: "Sin compensación",
        },
        {
          id: "no_applicable_compensation",
          name: "No aplica",
        },
      ],
    };
  },
  methods: {
    textCompensation(compensation) {
      return this.optionsCompensation.find((x) => x.id == compensation)?.name;
    },
    findItem(id) {
      const me = this;
      me.$router.push({
        name: "detailPCL",
        params: { employee_id: me.employeeId, pcl_id: id, is_edit: false },
      });
    },
    editItem(id) {
      const me = this;
      me.$router.push({
        name: "editPCL",
        params: { employee_id: me.employeeId, pcl_id: id, is_edit: true },
      });
    },
    deleteItem(id) {
      const me = this;
      me.$emit("deleteItem", id);
    },
  },
};
</script>

<style lang="css">
.custom-tooltip-ht .tooltip-inner {
  max-width: 200px !important;
  background-color: #263238 !important;
  font-size: 14px !important;
}
.text-file {
  color: #1719da80;
  font-size: 16px;
  cursor: pointer;
}
.list-diagnostic {
  list-style: disc !important;
  padding: 0 !important;
}
.list-diagnostic li {
  overflow: hidden;
  width: 250px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
